"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "text-center font-bold" };
const vue_3 = require("vue");
const debounce_1 = __importDefault(require("lodash/debounce"));
const TyreFilter_vue_1 = __importDefault(require("../../components/ProductSearch/TyreFilter.vue"));
const DropdownInput_vue_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInput.vue"));
const i18n_1 = require("../../common/i18n");
const DropdownInputItem_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInputItem"));
const productFilterStore_1 = require("../../stores/product/filter/productFilterStore");
const vue_router_1 = require("vue-router");
const SkuTagSearchInput_vue_1 = __importDefault(require("../../components/ProductSearch/SkuTagSearchInput.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProductBySku',
    setup(__props) {
        const SEARCH_TYPES = ['manufacturerSku', 'ean', 'id'];
        const productFilterStore = (0, productFilterStore_1.useProductFilterStore)();
        const router = (0, vue_router_1.useRouter)();
        const tyreFilterRef = (0, vue_3.ref)();
        const selectedSearchType = (0, vue_3.ref)("id");
        const searchValue = (0, vue_3.ref)("");
        const form = (0, vue_3.ref)({});
        const initialTags = (0, vue_3.ref)([]);
        const skuTagSearchInputRef = (0, vue_3.ref)(null);
        const searchTypeOptions = (0, vue_3.ref)([
            new DropdownInputItem_1.default('manufacturerSku', (0, i18n_1.trans)('manufacturerSku', 'Manufacturer sku', 'sku_search')),
            new DropdownInputItem_1.default('ean', (0, i18n_1.trans)('ean', 'EAN', 'sku_search')),
            new DropdownInputItem_1.default('id', (0, i18n_1.trans)('id', 'Marso id', 'sku_search'))
        ]);
        const placeholderText = (0, vue_3.computed)(() => {
            switch (selectedSearchType.value) {
                case 'manufacturerSku':
                    return (0, i18n_1.trans)('manufacturerSku', 'Manufacturer sku', 'sku_search');
                case 'ean':
                    return (0, i18n_1.trans)('ean', 'EAN', 'sku_search');
                case 'id':
                    return (0, i18n_1.trans)('id', 'Marso id', 'sku_search');
                default:
                    return '';
            }
        });
        const optionsByType = (0, vue_3.computed)(() => ({
            manufacturerSku: productFilterStore.manufacturerSkuSearchInputOptions,
            id: productFilterStore.idSearchInputOptions,
            ean: productFilterStore.eanSearchInputOptions
        }));
        const currentOptions = (0, vue_3.computed)(() => {
            return optionsByType.value[selectedSearchType.value] || [];
        });
        const handleSelect = (option) => {
            searchValue.value = option.value;
        };
        const handleTagsChanged = (tags) => {
            var _a, _b;
            const values = tags.map(tag => tag.value);
            if (values.length > 0) {
                form.value[selectedSearchType.value] = values;
                (_a = tyreFilterRef.value) === null || _a === void 0 ? void 0 : _a.search();
            }
            else {
                (_b = tyreFilterRef.value) === null || _b === void 0 ? void 0 : _b.resetFilters();
            }
        };
        const loadSavedSearchType = () => {
            const saved = localStorage.getItem('productBySku_searchType');
            if (saved && SEARCH_TYPES.includes(saved)) {
                return saved;
            }
            return 'id';
        };
        const initializeFromQuery = () => {
            let foundInQuery = false;
            for (const searchType of SEARCH_TYPES) {
                const queryValue = router.currentRoute.value.query[searchType];
                if (queryValue) {
                    selectedSearchType.value = searchType;
                    foundInQuery = true;
                    let values;
                    if (Array.isArray(queryValue)) {
                        values = queryValue;
                    }
                    else if (typeof queryValue === 'object' && queryValue !== null) {
                        values = Object.values(queryValue);
                    }
                    else {
                        values = [queryValue];
                    }
                    form.value[searchType] = values;
                    initialTags.value = values;
                    break;
                }
            }
            if (!foundInQuery) {
                selectedSearchType.value = loadSavedSearchType();
            }
        };
        const getOptionsForSearch = (0, debounce_1.default)(async (value, type) => {
            try {
                if (!value)
                    return;
                const query = { [type]: value };
                await productFilterStore.getProductFilters(router, query);
            }
            catch (error) {
                console.error('Error fetching options for search:', error);
            }
        }, 300);
        (0, vue_3.watch)(selectedSearchType, (newValue) => {
            localStorage.setItem('productBySku_searchType', newValue);
        });
        (0, vue_3.watch)([searchValue, selectedSearchType], ([value, type]) => {
            getOptionsForSearch(value, type);
        });
        (0, vue_3.onBeforeMount)(() => {
            initializeFromQuery();
        });
        return (_ctx, _cache) => {
            var _a;
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TyreFilter_vue_1.default, {
                ref_key: "tyreFilterRef",
                ref: tyreFilterRef,
                "search-label": (0, vue_2.unref)(i18n_1.trans)('sku_seach', 'Product search by SKU', 'sku_search'),
                form: form.value,
                "need-tag-search": false,
                category: "carTyre"
            }, (0, vue_2.createSlots)({
                filtersPrepend: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                        modelValue: selectedSearchType.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedSearchType).value = $event)),
                        placeholder: (0, vue_2.unref)(i18n_1.trans)('category', 'Category', 'sku_search'),
                        items: searchTypeOptions.value,
                        "disable-deselect": ""
                    }, null, 8, ["modelValue", "placeholder", "items"])
                ]),
                defaultFilters: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createVNode)(SkuTagSearchInput_vue_1.default, {
                        id: "product-by-sku-tag-search-input",
                        ref_key: "skuTagSearchInputRef",
                        ref: skuTagSearchInputRef,
                        modelValue: searchValue.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((searchValue).value = $event)),
                        placeholder: (0, vue_2.unref)(placeholderText),
                        options: (0, vue_2.unref)(currentOptions),
                        "search-type": selectedSearchType.value,
                        "initial-tags": initialTags.value,
                        onSelect: handleSelect,
                        onTagsChanged: handleTagsChanged
                    }, null, 8, ["modelValue", "placeholder", "options", "search-type", "initial-tags"])
                ]),
                _: 2
            }, [
                (skuTagSearchInputRef.value && ((_a = skuTagSearchInputRef.value) === null || _a === void 0 ? void 0 : _a.hasInvalidTag))
                    ? {
                        name: "additionalElements",
                        fn: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("div", _hoisted_1, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('invalid_yellow_skus', 'Please note that the SKUs highlighted in yellow are not valid.', 'sku_search')), 1)
                        ]),
                        key: "0"
                    }
                    : undefined
            ]), 1032, ["search-label", "form"]));
        };
    }
});
